import React, { useState, useEffect } from 'react'

const REGLES = [
  {
    icon: '✓',
    color: '#16a34a',
    bg: '#f0fdf4',
    border: '#bbf7d0',
    titre: 'Donner les points quand le défi est réussi',
    desc: 'Cochez la case du défi uniquement si l\'élève a réussi ce défi durant la journée. Un demi-succès peut être valorisé avec le bonus.'
  },
  {
    icon: '★',
    color: '#d97706',
    bg: '#fffbeb',
    border: '#fde68a',
    titre: 'Le bonus : pour valoriser les actions positives',
    desc: 'Utilisez le bonus pour récompenser des comportements positifs en dehors des défis : collaborer spontanément, aider un camarade, coopérer, faire preuve de bienveillance...'
  },
  {
    icon: '✕',
    color: '#dc2626',
    bg: '#fef2f2',
    border: '#fecaca',
    titre: 'Ne jamais enlever de points',
    desc: 'Ce tableau est uniquement un outil de valorisation. On n\'enlève jamais de points, même en cas de mauvais comportement. Si un défi n\'est pas réussi, on laisse simplement la case vide.'
  },
  {
    icon: '↔',
    color: '#2563eb',
    bg: '#eff6ff',
    border: '#bfdbfe',
    titre: 'Communiquer avec les parents',
    desc: 'Utilisez l\'espace "Notes" pour transmettre des observations aux parents chaque semaine. Ils peuvent aussi vous laisser des messages pour vous tenir informé.'
  }
]

export default function ReglesEcole({ onFermer }) {
  return (
    <div style={{ background: '#fff', borderRadius: 20, maxWidth: 520, width: '100%', maxHeight: '85vh', overflow: 'hidden', display: 'flex', flexDirection: 'column', boxShadow: '0 25px 60px rgba(0,0,0,0.2)' }}>
      {/* Header */}
      <div style={{ background: 'linear-gradient(135deg, #1e3a5f, #2563eb)', padding: '20px 24px', color: '#fff', flexShrink: 0 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 20, margin: 0, fontWeight: 700 }}>Guide de remplissage</h2>
            <p style={{ margin: '4px 0 0', fontSize: 12, opacity: 0.75 }}>Comment bien utiliser le tableau côté école</p>
          </div>
          {onFermer && (
            <button onClick={onFermer} style={{ background: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: 8, padding: '6px 12px', color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 600, fontFamily: "'Inter',sans-serif" }}>
              Fermer
            </button>
          )}
        </div>
      </div>

      {/* Contenu */}
      <div style={{ flex: 1, overflow: 'auto', padding: '20px 24px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {REGLES.map((r, i) => (
            <div key={i} style={{ background: r.bg, borderRadius: 12, padding: '14px 16px', border: `1px solid ${r.border}` }}>
              <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                <div style={{ width: 32, height: 32, borderRadius: '50%', background: r.color, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <span style={{ color: '#fff', fontSize: 14, fontWeight: 800 }}>{r.icon}</span>
                </div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 14, color: '#1e293b', marginBottom: 4 }}>{r.titre}</div>
                  <div style={{ fontSize: 13, color: '#475569', lineHeight: 1.6 }}>{r.desc}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <div style={{ padding: '14px 24px', borderTop: '1px solid #e2e8f0', background: '#f8fafc', flexShrink: 0 }}>
        <button onClick={onFermer} style={{ width: '100%', padding: '10px', borderRadius: 10, border: 'none', background: '#2563eb', color: '#fff', fontWeight: 700, fontSize: 14, cursor: 'pointer', fontFamily: "'Inter',sans-serif" }}>
          Compris, je commence !
        </button>
      </div>
    </div>
  )
}

// Hook pour afficher la popup au 1er accès école
export function useReglesEcole() {
  const [show, setShow] = useState(false)
  useEffect(() => {
    const vu = localStorage.getItem('kudogenius_regles_ecole_vues')
    if (!vu) { setShow(true); localStorage.setItem('kudogenius_regles_ecole_vues', '1') }
  }, [])
  return [show, () => setShow(false)]
}
